module.exports = __webpack_public_path__ + "static/media/saveTimeIcon.a31c98e2.svg";